<template>
  <b-modal :id="'ModalImpressao'" header-class="modal-cabecalho" auto-focus-button>
    <Header mini titulo="Impressão" icone="print" cor="azul" slot="modal-header" />
    <template>
      <div class="modal-impressao-info" v-if="nomeCenarioModal">
        Impressão de relatório: <b>{{ nomeCenarioModal }}</b>
      </div>
      <div class="modal-impressao-info" v-else>
        Impressão de relatório: <b>Cenário {{ id }}</b>
      </div>
      <ModalImpressaoLoading :loading="loading" />
      <div class="modal-impressao-corpo">
        <ModalImpressaoCheck
          :montagemCheck="montagemCheck"
          :exibe="exibe"
          :todosImpostos="todosImpostos"
          :resetModal="resetModal"
        />
      </div>
    </template>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="handleModalClose"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Imprimir"
        icone="check"
        :click="handlePrint"
        :desabilita="!selecionadoCheck || loading"
        :tooltip="!selecionadoCheck ? 'Selecione um tributo para habilitar a impressão' : ''"
        :loading="loading"
        cor="azul"
      />
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Api from "@/services/api.js";
import ModalImpressaoBotao from "./ModalImpressaoBotao.vue";
import ModalImpressaoCheck from "./ModalImpressaoCheck.vue";
import ModalImpressaoLoading from "./ModalImpressaoLoading.vue";
import ModalImpressaoTitulo from "./ModalImpressaoTitulo.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

//para adicionar novo imposto preencher o array campo e colocar novo objeto dentro do array montagemCheck
export default {
  name: "modalImpressao",
  components: {
    ModalImpressaoBotao,
    ModalImpressaoCheck,
    ModalImpressaoLoading,
    ModalImpressaoTitulo,
    BotaoPadrao,
    Header
  },
  props: {
    id: Number,
    modalImpressaoToggle: Boolean,
    imprimirResultado: Function,
    nomeCenarioModal: String
  },
  data() {
    return {
      selecionou: {},
      exibe: [],
      loading: false,
      salvaImpressao: true,
      montagemCheck: [
        {
          label: "PREFERÊNCIA TARIFÁRIA",
          model: false,
          campo: "PREFERENCIA_TARIFARIA",
          ativo: false
        },
        {
          label: "IMPOSTO DE EXPORTAÇÃO",
          model: false,
          campo: "IMPOSTO_EXPORTACAO",
          ativo: false
        },
        {
          label: "IMPOSTO DE IMPORTAÇÃO",
          model: false,
          campo: "IMPOSTO_IMPORTACAO",
          ativo: false
        },
        {
          label: "DEFESA COMERCIAL",
          model: false,
          campo: "DEFESA_COMERCIAL",
          ativo: false
        },
        {
          label: "IPI",
          model: false,
          campo: "IPI",
          ativo: false
        },
        {
          label: "PIS/COFINS",
          model: false,
          campo: "PIS_COFINS",
          ativo: false
        },
        {
          label: "CIDE COMBUSTÍVEL",
          model: false,
          campo: "CIDE_COMBUSTIVEL",
          ativo: false
        },
        {
          label: "ICMS",
          model: false,
          campo: "ICMS",
          ativo: false
        },
        {
          label: "ICMS ST",
          model: false,
          campo: "ICMS_ST",
          ativo: false
        },
        {
          label: "ICMS CARGA LÍQUIDA",
          model: false,
          campo: "ICMS_CARGA_LIQUIDA",
          ativo: false
        },
        {
          label: "ICMS ANTECIPAÇÃO TRIBUTARIA",
          model: false,
          campo: "ICMS_ANTECIPACAO_TRIBUTARIA",
          ativo: false
        },
        {
          label: "ICMS DIFERENCIAL DE ALÍQUOTAS",
          model: false,
          campo: "ICMS_DIFERENCIAL_DE_ALIQUOTAS",
          ativo: false
        }
      ]
    };
  },
  watch: {
    modalImpressaoToggle: {
      deep: true,
      handler() {
        this.salvaImpressao = true;
        this.limpaModel();
        this.selecao(this.getSelecao[this.id - 1]);
        this.exibe = this.getPossiveisAbasCenario(this.id)
          ? this.getPossiveisAbasCenario(this.id)
          : [];
        // if (this.modalImpressaoToggle == true) {
        this.$root.$emit("bv::show::modal", "ModalImpressao");
        // } else {
        // this.$root.$emit("bv::hide::modal", "ModalImpressao");
        // }
      }
    },
    impostoSelecionadoImpressao() {
      this.$emit("selecaoImpressao", this.impostoSelecionadoImpressao);
    }
  },
  methods: {
    ...mapActions("reRender", ["setRenderKey"]),
    limpaModel() {
      this.montagemCheck.forEach(e => {
        e.model = false;
      });
    },
    selecao(data) {
      this.montagemCheck.forEach(p => {
        if (p.campo == "IMPOSTO_IMPORTACAO") {
          p.ativo = data.selecionouImportacao;
          if (!data.selecionouImportacao) {
            p.model = false;
          }
        }
        if (p.campo == "PREFERENCIA_TARIFARIA") {
          p.ativo = data.selecionouPreferenciaTarifaria;
          if (!data.selecionouPreferenciaTarifaria) {
            p.model = false;
          }
        }
        if (p.campo == "IMPOSTO_EXPORTACAO") {
          p.ativo = data.selecionouExportacao;
          if (!data.selecionouExportacao) {
            p.model = false;
          }
        }
        if (p.campo == "IPI") {
          p.ativo = data.selecionouIpi;
          if (!data.selecionouIpi) {
            p.model = false;
          }
        }
        if (p.campo == "PIS_COFINS") {
          p.ativo = data.selecionouPisCofins;
          if (!data.selecionouPisCofins) {
            p.model = false;
          }
        }
        if (p.campo == "DEFESA_COMERCIAL") {
          p.ativo = data.selecionouDefesaComercial;
          if (!data.selecionouDefesaComercial) {
            p.model = false;
          }
        }
        if (p.campo == "CIDE_COMBUSTIVEL") {
          p.ativo = data.selecionouCideCombustivel;
          if (!data.selecionouCideCombustivel) {
            p.model = false;
          }
        }
        if (p.campo == "ICMS") {
          p.ativo = data.selecionouIcms;
          if (!data.selecionouIcms) {
            p.model = false;
          }
        }
        if (p.campo == "ICMS_ST") {
          p.ativo = data.selecionouIcmsSt;
          if (!data.selecionouIcmsSt) {
            p.model = false;
          }
        }
        if (p.campo == "ICMS_CARGA_LIQUIDA") {
          p.ativo = data.selecionouIcmsCargaLiquida;
          if (!data.selecionouIcmsCargaLiquida) {
            p.model = false;
          }
        }
        if (p.campo == "ICMS_ANTECIPACAO_TRIBUTARIA") {
          p.ativo = data.selecionouIcmsAntecipacao;
          if (!data.selecionouIcmsAntecipacao) {
            p.model = false;
          }
        }
        if (p.campo == "ICMS_DIFERENCIAL_DE_ALIQUOTAS") {
          p.ativo = data.selecionouIcmsDifal;
          if (!data.selecionouIcmsDifal) {
            p.model = false;
          }
        }
      });
    },
    async handlePrint() {
      this.setRenderKey();
      let payload = {
        dadosCenario: this.getDadosForm[this.id],
        dadosRequisicao: this.getLog
      };
      this.loading = true;
      if (this.salvaImpressao && !this.blUsuarioPro) {
        this.salvaImpressao = false;
        try {
          let response = await new Api().post("Impressao/salvarLogImpressao", payload);
          if (response.status) {
            // console.log(response);
            setTimeout(() => {
              this.loading = false;
              window.print();
            }, 100);
          }
        } catch (error) {
          console.error(error);
          this.loading = false;
        }
      } else {
        setTimeout(() => {
          this.loading = false;
          window.print();
        }, 100);
      }
    },
    handleModalClose() {
      this.$root.$emit("bv::hide::modal", "ModalImpressao");
    },
    resetModal() {
      this.montagemCheck.forEach(p => (p.model = false));
    },
    todosImpostos() {
      this.montagemCheck.forEach(p => {
        if (this.exibe.includes(p.campo) && p.ativo == true) {
          p.model = true;
        }
      });
    }
  },
  computed: {
    ...mapGetters("form", ["getDadosForm"]),
    ...mapGetters("tributosSelecionados", ["getSelecao"]),
    ...mapGetters("resultado", ["getImpostos", "getPossiveisAbas", "getPossiveisAbasCenario"]),
    ...mapGetters("logResultados", ["getLog"]),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),

    impostoSelecionadoImpressao() {
      let campo = [];
      this.montagemCheck.forEach(p => {
        if (p.model) {
          campo.push(p.campo);
        }
      });
      return campo;
    },
    selecionadoCheck() {
      let selecionado = this.montagemCheck.filter(p => p.model);
      if (!selecionado.length) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/css/var.scss";

.impressao-fora {
  display: block;
  position: fixed;
  z-index: 50;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: $modalExterno;
}
.modal-impressao-corpo {
  background: var(--branco);
  height: fit-content;
  position: relative;
  z-index: 100;
}
.impressao-divisor {
  display: flex;
  flex-direction: column;
}
.modal-icone-imprimir {
  font-size: 40px;
  margin: 5px 0;
  color: var(--azul2);
}
.modal-impressao-info {
  text-align: center;
}
</style>
